// eslint-disable-next-line unused-imports/no-unused-vars
/* global sendinblue */

import letrusAPI from 'APIs/letrusAPI/axiosInstance';

/**
 * HUBSPOT API
 */

export async function hubspotTokenToIdentifyUserToWebChat() {
  return letrusAPI(
    `${
      import.meta.env.REACT_APP_API_URL
    }/api/v1/hubspot_visitor_identification/`,
    {
      method: 'get',
    }
  )
    .then((response) => response.data)
    .catch(() => console.log('Hubspot error'));
}

/**
 * End HUBSPOT
 */
